<template>
  <header class="red">
    <v-container class="py-0">
      <v-app-bar-nav-icon
        v-if="$vuetify.breakpoint.mdAndDown"
        color="white"
        @click.stop="isDrawerOpen = !isDrawerOpen"
      />

      <v-navigation-drawer v-if="$vuetify.breakpoint.mdAndDown" v-model="isDrawerOpen" absolute temporary>
        <v-list nav>
          <v-list-item-group>
            <v-list-item v-if="checkAccess('Dashboard')" to="/">
              <div>Dashboard</div>
            </v-list-item>
            <!-- <v-list-item v-if="checkAccess('AccountDetails')" :to="{ name: 'AccountDetails' }">
              <div>Account Details</div>
            </v-list-item> -->
            <v-list-item v-if="canAccessReports" :to="{ name: 'Reports' }">
              <div>Reports</div>
            </v-list-item>
            <v-list v-if="canAccessReports" nav subheader>
              <v-list-item-group>
                <v-list-item :to="{ name: 'MaxDemand' }">
                  <div>Consumption and Demand</div>
                </v-list-item>
                <v-list-item :to="{ name: 'Comparison' }">
                  <div>Comparison</div>
                </v-list-item>
                <v-list-item to="/reports/interval-data">
                  <div>Interval Data</div>
                </v-list-item>
                <v-list-item to="/reports/interval-data-via-email">
                  <div>Interval Data via Email</div>
                </v-list-item>
              </v-list-item-group>
            </v-list>
            <v-list-item v-if="checkAccess('SummaryAndNominations')" :to="{ name: 'SummaryAndNominations' }">
              <div>Progressive Purchasing</div>
            </v-list-item>
            <v-list-item v-if="checkAccess('BillHistory')" :to="{ name: 'BillHistory' }">
              <div>Bill History</div>
            </v-list-item>
            <v-list-item v-if="checkAccess('CustomGroups')" :to="{ name: 'CustomGroups' }">
              <div>Custom Groups</div>
            </v-list-item>
            <v-list-item v-if="checkAccess('ContactUs')" :to="{ name: 'ContactUs' }">
              <div>Contact Us</div>
            </v-list-item>
            <v-list v-if="authState.isAuthenticated" nav subheader>
              <v-list-item-group>
                <v-list-item :to="{ name: 'ChangePassword' }">
                  <div>Change Password</div>
                </v-list-item>
                <v-list-item>
                  <div>
                    <a id="logout-button" class="item" @click="logout()"> Logout </a>
                  </div>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-list-item-group>
        </v-list>
      </v-navigation-drawer>

      <nav v-if="$vuetify.breakpoint.lgAndUp" class="nav-header">
        <div class="nav-header__nav">
          <router-link to="/" class="nav-header__logo mr-6">
            <img src="/images/logo-snowy.svg" width="85" height="16" />
          </router-link>
          <router-link to="/" class="nav-header__logo mr-12">
            <img src="/images/logo-red.svg" width="83" height="40" />
          </router-link>
          <template v-if="authState.isAuthenticated">
            <router-link v-if="checkAccess('Dashboard')" to="/" class="nav-header__link">Dashboard</router-link>
            <v-menu v-if="renderReportsMenu" content-class="nav-header__menu" open-on-click offset-y>
              <template #activator="{ on }">
                <a
                  v-if="canAccessReports"
                  ref="reports"
                  :class="`nav-header__link nav-header__link--has-menu ${reportsActive}`"
                  v-on="on"
                >
                  Reports
                </a>
              </template>
              <v-list>
                <v-list-item>
                  <router-link :to="{ name: 'MaxDemand' }">Consumption and Demand</router-link>
                </v-list-item>
                <v-list-item>
                  <router-link :to="{ name: 'Comparison' }">Comparison</router-link>
                </v-list-item>
                <v-list-item>
                  <router-link :to="{ name: 'IntervalData' }">Interval Data</router-link>
                </v-list-item>
                <v-list-item>
                  <router-link :to="{ name: 'IntervalDataViaEmail' }">Interval Data via Email</router-link>
                </v-list-item>
              </v-list>
            </v-menu>
            <router-link
              v-if="checkAccess('SummaryAndNominations')"
              :to="{ name: 'SummaryAndNominations' }"
              class="nav-header__link"
            >
              Progressive Purchasing
            </router-link>
            <router-link v-if="checkAccess('BillHistory')" :to="{ name: 'BillHistory' }" class="nav-header__link">
              Bill History
            </router-link>
            <router-link v-if="checkAccess('CustomGroups')" :to="{ name: 'CustomGroups' }" class="nav-header__link">
              Custom Groups
            </router-link>
            <router-link v-if="checkAccess('ContactUs')" :to="{ name: 'ContactUs' }" class="nav-header__link">
              Contact Us
            </router-link>
          </template>
        </div>
        <div v-if="authState.isAuthenticated" class="nav-header__user">
          <router-link v-if="checkAccess('Access')" :to="{ name: 'Access' }" class="nav-header__link">
            Access
          </router-link>
          <span v-if="userName" class="nav-header__name mr-6">Hi {{ userName }}</span>

          <v-menu content-class="nav-header__menu" offset-y>
            <template #activator="{ on, attrs }">
              <a ref="user" class="nav-header__link nav-header__link--has-menu" v-bind="attrs" v-on="on">
                <v-icon color="#fff" medium>mdi-account-circle</v-icon>
              </a>
            </template>
            <v-list>
              <v-list-item>
                <router-link :to="{ name: 'ChangePassword' }">Change Password</router-link>
              </v-list-item>
              <v-list-item>
                <a @click="logout()">Logout</a>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </nav>
    </v-container>
  </header>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'NavHeader',
  data() {
    return {
      isDrawerOpen: false,
      renderReportsMenu: false,
      reportsActive: '',
    }
  },
  computed: {
    ...mapGetters({
      checkAccess: 'auth/checkAccess',
    }),
    ...mapState({
      userName: state => state.auth.user.firstName,
    }),
    canAccessReports() {
      return this.checkAccess('Reports')
    },
  },
  watch: {
    canAccessReports(canAccess) {
      if (canAccess) this.$nextTick(() => (this.renderReportsMenu = true))
    },
    $route() {
      this.$router.currentRoute.path.includes('/reports/')
        ? (this.reportsActive = 'router-link-exact-active')
        : (this.reportsActive = '')
    },
  },
  mounted() {
    if (this.canAccessReports) this.$nextTick(() => (this.renderReportsMenu = true))
  },
  methods: {
    async logout() {
      const idToken = await this.$auth.getIdToken()
      await this.$auth.signOut()
      // Clear remote session
      //window.location.href = `${process.env.VUE_APP_OKTA_ISSUER}/v1/logout?id_token_hint=${idToken}`
    },
  },
}
</script>

<style lang="scss" scoped>
.nav-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 62px;

  &__nav {
    display: flex;
  }

  &__user {
    display: flex;
    color: #fff;
    align-items: center;
    @media only screen and (min-width: 1263px) and (max-width: 1904px) {
      font-size: 13px;
    }
  }

  &__logo {
    display: flex;
    align-items: center;
  }

  &__link {
    color: #fff;
    margin-right: 24px;
    font-size: 16px;
    display: flex;
    align-items: center;
    height: 62px;
    border-bottom: 2px solid transparent;
    transition: border ease-out 150ms;
    @media only screen and (min-width: 1263px) and (max-width: 1904px) {
      font-size: 13px;
    }

    &.router-link-exact-active {
      border-bottom: 2px solid #fff;
    }
  }

  &__link--has-menu {
    &.router-link-active {
      border-bottom: 2px solid #fff;
    }
  }

  &__menu {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }
}
</style>
